"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const useCardExercise_1 = require("@app/routes/SpeechDevelopment/hooks/useCardExercise");
const Content_1 = require("@app/routes/SpeechDevelopment/exersices/FillGaps/Content");
const FiilGapsExerciseHandler_1 = require("@app/routes/SpeechDevelopment/exersices/FillGaps/handlers/FiilGapsExerciseHandler");
const ExercisePlayer_1 = require("@app/routes/SpeechDevelopment/components/ExercisePlayer");
const FillGaps = ({ exerciseParams, description }) => {
    const exerciseCard = (0, useCardExercise_1.useCardExercise)({ exerciseParams }, FiilGapsExerciseHandler_1.FillGapsExerciseHandler);
    return (react_1.default.createElement(ExercisePlayer_1.ExercisePlayer, { exerciseCard: exerciseCard, content: Content_1.Content }));
};
exports.default = FillGaps;
